import { useCallback } from 'react';

/**
 * useClientIp
 * Exposes an async getIp(opts) -> Promise<string>
 * - opts.url: public IP service URL (default: ipify)
 * - opts.timeout: ms before aborting (default: 3000)
 * - opts.defaultIp: fallback IP string on failure (default: '0.0.0.0')
 */
export default function useClientIp() {
  const getIp = useCallback(async (opts = {}) => {
    const {
      url = 'https://api.ipify.org?format=json',
      timeout = 3000,
      defaultIp = '0.0.0.0',
      setLoading
    } = opts;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
        setLoading(true);
        const resp = await fetch(url, { signal: controller.signal });
        clearTimeout(id);
        if (!resp.ok) return defaultIp;
        const json = await resp.json();
        return (json && json.ip) ? json.ip : defaultIp;
    } catch (err) {
        // network error, timeout, CORS, etc. — return fallback
        return defaultIp;
    } finally {
        setLoading(false);
        clearTimeout(id);
    }
  }, []);

  return { getIp };
}